import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const fieldBlockCss = "f1l3uo6g";
export const FieldBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldBlockCss, props.className)} />;
});
const labelCss = "l1v4wrgf";
export const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
const containerIsSmallPhoneCss = "cm2rmhm";
const containerCss = "c1j45gat";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const counterNotValidCss = "cukovm3";
const counterCss = "cx9eokw";
export const Counter = forwardRef((props, ref) => {
  const {
    notValid,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(counterCss, {
    [counterNotValidCss]: notValid
  }, props.className)} />;
});
const counterContainerCss = "c1dhd65z";
export const CounterContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(counterContainerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");